const brochures = [
  {
    slug: "rice",
    name: "Rice",
    tagline: "Premium grade basmati & non-basmati rice",
    image: "product.jpg",
    pdf: "RICE.pdf",
  },
  {
    slug: "spices",
    name: "Spices",
    tagline: "Whole & ground spices, seeds and blends",
    image: "product2.jpg",
    pdf: "Spices.pdf",
  },
  {
    slug: "dal",
    name: "Dal",
    tagline: "Pulses and lentils sourced for quality",
    image: "product.jpg",
    pdf: "DAL.pdf",
  },
  {
    slug: "dehydrated",
    name: "Dehydrated",
    tagline: "Dehydrated vegetables and fruits",
    image: "product2.jpg",
    pdf: "Dehydrated.pdf",
  },
  {
    slug: "oil",
    name: "Oil",
    tagline: "Cold-pressed and refined edible oils",
    image: "product.jpg",
    pdf: "OIL.pdf",
  },
];

export default brochures;